import React from 'react';
import { findDOMNode, render, unmountComponentAtNode } from 'react-dom';
import { Provider } from 'react-redux';

export default class Portal extends React.Component {

	static contextTypes = {
    	store: React.PropTypes.object,
  	};

	componentDidMount() {

		var body = findDOMNode(this).closest('.b3-virtual-body') || document.body;

		this.portal = document.createElement('div');
		this.portal.className = "b3-portal";
		this.portal.portalOrigin = this.refs.origin; //used by outside click handler
		
		body.insertBefore(this.portal, body.firstChild);
		this.renderDialogContent(this.props);
	}

	renderDialogContent(props) {
		// Wrapping this in Provider allows the content inside the Portal to still access the store from context where it normally wouldn't because it is outside the render tree for the root node.
        var style = Object.assign({fontFamily: 'Proxima Nova', position: 'absolute', left: 0, top: 0}, this.props.style);
		if(this.context.store) {
			var comp = (
				<Provider store={this.context.store}>
					<div style={style}>{props.children}</div>
				</Provider>
			);
		} else {
			var comp = (
				<div style={style}>{props.children}</div>
			);
		}
		
		render(comp, this.portal);
	}

	componentWillReceiveProps(newProps) {
		this.renderDialogContent(newProps);
	}

	componentWillUnmount() {
		unmountComponentAtNode(this.portal);
		this.portal.remove();
	}

	render() {
		return <noscript ref="origin"></noscript>;
	}

}



// WEBPACK FOOTER //
// ./app/b3/misc/Portal.js